/**
 * CLE-2851 — the "Hospital Staff Access" switch for the Hospital Staff Bot depends on the
 * bot switch above it. Pure, so the interaction is unit-testable without rendering the form.
 */

/** How the staff switch renders: off and disabled while the bot itself is off. */
export function contractChatbotStaffSwitchState(
  botEnabled: boolean,
  staffEnabled: boolean | null | undefined
): { checked: boolean; disabled: boolean } {
  return { checked: botEnabled && !!staffEnabled, disabled: !botEnabled };
}

/**
 * The staff switch's value after the bot switch is flipped: turning the bot OFF turns staff access
 * off too; turning the bot on leaves staff access as it was (off, for a bot that was just off).
 */
export function staffValueAfterBotToggle(
  botEnabled: boolean,
  staffEnabled: boolean | null | undefined
): boolean {
  return botEnabled ? !!staffEnabled : false;
}

/** What gets saved: never on for an account without a bot. */
export function contractChatbotStaffValueToSave(
  botEnabled: boolean | null | undefined,
  botId: number | null | undefined,
  staffEnabled: boolean | null | undefined
): boolean {
  return Boolean(botEnabled && botId && staffEnabled);
}
